/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SecurityExchangeRightsPeriodBasis {
    FIXED_DATE = 'FIXED_DATE',
    RELATIVE_TO_ISSUE_DATE = 'RELATIVE_TO_ISSUE_DATE',
    UNRESTRICTED = 'UNRESTRICTED',
}
